export enum PageEnum {
    // basic login path
    BASE_LOGIN = '/login',
    // basic home path
    BASE_HOME = '/screenshow',
    BASE_NYX_INDEX = '/agscreenshow',
    // error page path
    ERROR_PAGE = '/exception',
    // error log page path
    ERROR_LOG_PAGE = '/error-log/list',
    // ifram error page path
    ifram_ERROR_PAGE = '/expired',
}
